import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { PaginatedApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

export type Category = {
  categoryId: string;
  name: string;
  amount: number;
  vat: number;
  isPaid: boolean;
};

export type Landlord = {
  landlordId: string;
  name: string;
  email: string;
};

export type TicketHistory = {
  status: string;
  reason?: string;
  createdAt: string;
  updatedAt: string;
};

export type ServiceRequest = {
  ticketId: string;
  srNumber: string;
  category: Category;
  ticketStatus: string;
  serviceType: "Paid" | "Unpaid";
  landlord: Landlord;
  ticketStatusHistory: TicketHistory[];
  createdAt: string;
};

type Params = Record<string, unknown>;

type UseGetServiceRequestsOptions = {
  params?: Params;
  isEnabled?: boolean;
};

const getServiceRequests = async (params: Params) => {
  const url = `${apiV1Endpoint}/general-services/service-requests`;
  const response = await axios.get<PaginatedApiResponse<ServiceRequest[]>>(url, { params });
  return response.data.result;
};

export const useGetServiceRequests = (options: UseGetServiceRequestsOptions = {}) => {
  const { params, isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["service-requests", params],
    queryFn: () => getServiceRequests(params),
    enabled: isEnabled,
  });

  return { serviceRequests: data, isLoadingServiceRequests: isLoading };
};
